<template>
  <div class="score-select" :class="{'short': maxCount < 6}">
    <van-rate 
      v-model="itemValue" 
      @change="onValueChange()" 
      :color="themeColor"
      :count="maxCount"
      :disabled="readonly"
      :size="28"
    />
  </div>
</template>

<script>
import { Rate } from 'vant';

export default {
  props: {
    item: Object,
    submitValue: Object,
    readonly: Boolean
  },
  emits: ['change'],
  data() {
    return {
      itemClone: null,
      itemValue: null
    };
  },
  computed: {
    themeColor() {
      return this.$store.state.formConfig.theme_color;
    },
    maxCount() {
      return this.item?.full_score || 5;
    }
  },
  components: {
    [Rate.name]: Rate
  },
  methods: {
    // 【1】itemValue值设置
    setItemValue() {
      this.itemValue = this.submitValue?.value || null;
    },
    // 【2】值监听
    onValueChange() {
      this.$emit('change', {
        value: this.itemValue
      });
    }
  },
  created() {
    this.setItemValue();
  },
  async mounted() {
    
  },
};
</script>

<style lang="less" scoped>
@import (reference) '@/assets/less/common.less';

.score-select {
  width: 100%;
  display: flex;
  justify-content: center;
  &.short {
    /deep/ .van-rate__item {
      padding: 0 10px;
    }
  }
}
</style>
